import { CardContent } from '../../../Shared/Card'
import { CardLoadingPlaceholder } from '../../../Shared/CardLoadingPlaceholder'

const LoadingPlaceholderCardContent = () => {
    return (
      <CardContent
        className='card-content'
      >
          <CardLoadingPlaceholder />
      </CardContent>
    )
}

export { LoadingPlaceholderCardContent }
